import React from 'react';

const MenuIcon = () => {
  return (
    <svg width="16" height="10" viewBox="0 0 16 10" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.5 5.8335H2.16667V4.16683H0.5V5.8335ZM0.5 9.16683H2.16667V7.50016H0.5V9.16683ZM0.5 2.50016H2.16667V0.833496H0.5V2.50016ZM3.83333 5.8335H15.5V4.16683H3.83333V5.8335ZM3.83333 9.16683H15.5V7.50016H3.83333V9.16683ZM3.83333 0.833496V2.50016H15.5V0.833496H3.83333Z" fill="currentColor"/>
    </svg>
  )
}

export default MenuIcon;